
export default {
  name: 'ConfigurableText',
  values: {
    color: undefined,
    fontSize: undefined,
    fontFamily: undefined,
    fontWeight: undefined,
    fontStretch: undefined,
    fontStyle: undefined,
    textTransform: undefined,
    textDecoration: undefined,
    textShadow: undefined,
    textAlign: undefined,
    lineHeight: undefined,
    whiteSpace: undefined,
    wordBreak: undefined,
    overflowWrap: undefined,
    userSelect: undefined,
  },
  meta: {
    extendable: false,
  },
}
